export enum NotificationStyle {
	Success = "success",
	Info = "info",
	// Warning = "warning", // existiert nur bei Inocon
	Error = "error",
}

export interface Notification {
	readonly style: NotificationStyle;
	readonly message: string;
	readonly duration?: number;
}
